import { getHTMLElementContentRect, getIndexesOfSiblingsInLine } from '@blaze-shared/shared-util';

import { SLOT_MINIMAL_WIDTH } from '../layout/column';

/** Finds minimal width of the column element */
// TODO: test
export function calcColumnMinWidth(columnElement?: HTMLElement | null): number {
  if (!columnElement) {
    return 0;
  }

  const { flexGrow, flexShrink, flexBasis } = columnElement.style;
  columnElement.style.flexGrow = '0';
  columnElement.style.flexShrink = '1';
  columnElement.style.flexBasis = SLOT_MINIMAL_WIDTH;

  const calculatedMinWidth = columnElement.offsetWidth;
  columnElement.style.flexGrow = flexGrow;
  columnElement.style.flexShrink = flexShrink;
  columnElement.style.flexBasis = flexBasis;

  return calculatedMinWidth;
}

export function calcMaxColumnWidth(allSlots: HTMLElement[], slot: HTMLElement): number {
  const { elementIndex, finishIndex } = getIndexesOfSiblingsInLine(allSlots, slot);

  const slotWidth = getHTMLElementContentRect(slot).width;
  if (elementIndex + 1 >= allSlots.length) {
    return slotWidth;
  }

  let followingColumnsAvailableWidth = 0;
  for (let i = elementIndex + 1; i <= finishIndex; i++) {
    const contentWidth = getHTMLElementContentRect(allSlots[i]).width;
    const paddingWidth = allSlots[i].getBoundingClientRect().width - contentWidth;
    const min = calcColumnMinWidth(allSlots[i]) - paddingWidth;
    followingColumnsAvailableWidth += Math.max(0, contentWidth - min);
  }

  return slotWidth + followingColumnsAvailableWidth;
}
